import React, { Fragment, useState, useContext, useEffect } from "react";
import { Container, Row, Col, Button, Form, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../../App";
import $ from "jquery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { postMethod } from "../../../requests";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";

const ClassesCategories = () => {
    const { t } = useTranslation();
    const [types, setTypes] = useState(null);
    const [loading, setLoading] = useState(true);
    const { checkServerData, setAlerts } = useContext(BasicContext);
    const [formChanged, setFormChanged] = useState(false);
    const [blockForm, setBlockForm] = useState(false);

    const getClassesTypes = async () => {
        const res = await postMethod("/get-classes-types");
        if (checkServerData(res)) {
            setTypes(res.data.types);
        }
        setLoading(false);
    };

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        types.forEach((l, i) => {
            if (l.class_type_code.length === 0 || !l.class_type_code.replace(/\s+/, "")) {
                errors.push(`${t("error.typeCodeIsEmpty")} (nr: ${i + 1})`);
                $(`#typeCode${i}`).addClass("is-invalid");
            }
            if (l.class_type_name.length === 0 || !l.class_type_name.replace(/\s+/, "")) {
                errors.push(`${t("error.typeNameIsEmpty")} (nr: ${i + 1})`);
                $(`#typeName${i}`).addClass("is-invalid");
            }
        });

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setBlockForm(true);
            setAlerts([{ variant: "info", message: t("info.updatingClassLvls") }]);
            classesTypesUpdate();
        }
    };

    const classesTypesUpdate = async () => {
        const res = await postMethod("/classes-types-update", { types: types });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "updateTypesClasses" }]);
            const list = [...types];
            list.forEach((e) => {
                e.class_type_added = false;
            });
            setTypes(list);
            setBlockForm(false);
            setFormChanged(false);
        } else setBlockForm(false);
    };

    const addNewType = () => {
        const list = [...types];
        list.push({
            class_type_id: types.length + 1,
            class_type_code: "",
            class_type_name: "",
            class_type_added: true,
        });
        setTypes(list);
        setFormChanged(true);
    };

    useEffect(() => {
        getClassesTypes();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Container>
                <Row>
                    <Col xs={12} className="px-4 px-lg-2 ">
                        <p className="h5 mt-5 mb-4">{t("classes.classesCategories")}</p>
                    </Col>
                </Row>
                <Row>
                    {loading && (
                        <Col xs={12} className="text-center">
                            <p className="h4">
                                {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                            </p>
                        </Col>
                    )}

                    {types && (
                        <Col xs={12} className="px-0 px-lg-3">
                            <Form onSubmit={checkValidation}>
                                <Table size="sm" responsive borderless>
                                    <thead>
                                        <tr>
                                            <th>{t("classes.types.typeCode")}</th>
                                            <th>{t("classes.types.typeName")}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {types.map((l, i) => (
                                            <tr key={i}>
                                                <td>
                                                    <Form.Control
                                                        value={l.class_type_code}
                                                        type="text"
                                                        onChange={(e) => {
                                                            const list = [...types];
                                                            list.forEach((el, j) => {
                                                                if (j === i) el.class_type_code = e.target.value.toUpperCase();
                                                            });
                                                            setTypes(list);
                                                            setFormChanged(true);
                                                            $(`#typeCode${i}`).removeClass("is-invalid");
                                                        }}
                                                        size="sm"
                                                        disabled={l.class_type_active === "N"}
                                                        id={`typeCode${i}`}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        value={l.class_type_name}
                                                        type="text"
                                                        onChange={(e) => {
                                                            const list = [...types];
                                                            list.forEach((el, j) => {
                                                                if (j === i) el.class_type_name = e.target.value;
                                                            });
                                                            setTypes(list);
                                                            setFormChanged(true);
                                                            $(`#typeName${i}`).removeClass("is-invalid");
                                                        }}
                                                        size="sm"
                                                        disabled={l.class_type_active === "N"}
                                                        id={`typeName${i}`}
                                                    />
                                                </td>
                                                <td>
                                                    {l.class_type_added && (
                                                        <Button
                                                            size="sm"
                                                            variant="outline-danger"
                                                            onClick={() => {
                                                                const list = [...types];
                                                                list.splice(i, 1);
                                                                setTypes(list);
                                                                setFormChanged(true);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faTrashAlt} />
                                                        </Button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                <Button className="mx-2" onClick={addNewType} variant="outline-secondary" size="sm">
                                    {t("classes.types.addNewType")}
                                </Button>
                                <Button type="submit" variant="primary" disabled={blockForm || !formChanged} className="my-4 d-block mx-3">
                                    {t("saveChanges")}
                                </Button>
                            </Form>
                        </Col>
                    )}
                </Row>
            </Container>
        </Fragment>
    );
};

export default ClassesCategories;
